import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [totalSeconds, setTotalSeconds] = useState(14 * 60 + 50);
  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const isLow = totalSeconds < 300;
  return <span className={`font-heading font-bold text-lg md:text-xl tabular-nums ${isLow ? 'text-red-400' : 'text-yellow-300'}`} style={isLow ? {
    animation: 'countdown-pulse 1s ease-in-out infinite'
  } : undefined} aria-live="polite" aria-label={`Tiempo restante: ${minutes} minutos y ${seconds} segundos`} data-id="element-1">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}